import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import Config from 'app/Config';
import { useResolveImageUrl } from './useResolveImageUrl';


const Image = ({ src, ...props }) => {
  const { finalSrc, SvgComponent, internalClass } = useResolveImageUrl(src);

  const mergedClassName = [internalClass, props.className, props.class].filter(Boolean).join(' ');

  if (SvgComponent) {
    return (
      <SvgComponent 
        className={mergedClassName} 
        url={finalSrc} 
        {...props} 
      />
    );
  }

  return (
    <img 
      src={finalSrc} 
      loading="lazy" 
      className={mergedClassName}        
      {...props} 
    />
  );
};

export default React.memo(Image);